module.exports = __webpack_public_path__ + "img/back.41580dfa.png";